export default {
    namespaced: true,

    state: {
        customer: {
            name: '',
            page: '',
            filter: '',
            perPage: 20
        },
        payment: {
            name: '',
            page: '',
            filter: '',
            perPage: 20
        },
        credit: {
            name: '',
            page: '',
            filter: '',
            perPage: 20
        },
        category: {
            name: '',
            page: '',
            filter: '',
            perPage: 20
        },
        attribute: {
            name: '',
            page: '',
            filter: '',
            perPage: 20
        },
        product: {
            sku: '',
            page: '',
            filter: '',
            rowFilters: {},
            perPage: 20
        },
        bundle: {
            sku: '',
            page: '',
            filter: '',
            rowFilters: {},
            perPage: 20
        },
        order: {
            name: '',
            page: '',
            filter: '',
            perPage: 20
        },
        stocktransfer: {
            name: '',
            page: '',
            filter: '',
            perPage: 20
        },
        batchpicks: {
            name: '',
            page: '',
            filter: '',
            perPage: 20
        }
    },

    getters: {
        customer (state) {
            return state.customer
        },

        payment (state) {
            return state.payment
        },

        credit (state) {
            return state.credit
        },

        category (state) {
            return state.category
        },

        attribute (state) {
            return state.attribute
        },

        product (state) {
            return state.product
        },

        bundle (state) {
            return state.bundle
        },

        order (state) {
            return state.order
        },

        stocktransfer (state) {
            return state.stocktransfer
        }
    },

    mutations: {
        SET_CUSTOMER (state, value) {
            state.customer = value
        },

        SET_PAYMENT (state, value) {
            state.payment = value
        },

        SET_CREDIT (state, value) {
            state.credit = value
        },

        SET_CATEGORY (state, value) {
            state.category = value
        },

        SET_ATTRIBUTE (state, value) {
            state.attribute = value
        },

        SET_PRODUCT (state, value) {
            state.product = value
        },

        SET_BUNDLE (state, value) {
            state.bundle = value
        },

        SET_ORDER (state, value) {
            state.order = value
        },

        SET_STOCKTRANSFER (state, value) {
            state.stocktransfer = value
        }
    },

    actions: {
        // setRemember({commit}, data) {
        //     commit('SET_CUSTOMER', data)
        // }
    }
}
